import http from '@/axios/http'

const post = ({ headers, data, url }) => {
  headers = {
    'Content-Type': 'application/json',
    ...headers
  }
  if (localStorage.getItem('token')) {
    headers.Auth = localStorage.getItem('token')
  }

  return http
    .post(
      url,
      data,
      { headers }
    )
    .then(response => response.data)
}

export const getFromEvent = (eventId) => {
  return post({
    url: '/get_fights_info',
    data: { ...eventId }
  })
}

export const initFight = (ids) => {
  return post({
    url: '/initialize_fight',
    data: { ...ids }
  })
}

export const infoJudgesScoresFight = (fightId) => {
  return post({
    url: '/get_judges_scores',
    data: { ...fightId }
  })
}

export const finishFight = (fightId) => {
  return post({
    url: '/end_fight_hacktudo',
    data: { ...fightId }
  })
}

export const enterFight = (ids) => {
  return post({
    url: '/enter_fight',
    data: { ...ids }
  })
}

export const enterRoundJudgeFight = (ids) => {
  return post({
    url: '/enter_fight_judge',
    data: { ...ids }
  })
}

export const generateKeys = (info) => {
  return post({
    url: '/generate_brackets',
    data: { ...info }
  })
}

export const categoryKeys = (ids) => {
  return post({
    url: '/get_brackets',
    data: { ...ids }
  })
}

export const fightAggressivity = (info) => {
  return post({
    url: '/post_judge_aggressivity',
    data: { ...info }
  })
}

export const fightDamage = (info) => {
  return post({
    url: '/post_judge_damage',
    data: { ...info }
  })
}

export const changeFightsTime = (fights) => {
  return post({
    url: '/change_fight_time',
    data: fights
  })
}

export const scheduleFights = (info) => {
  return post({
    url: '/schedule_fights',
    data: { ...info }
  })
}

export const reschedulePending = (info) => {
  return post({
    url: '/reschedule_pending',
    data: { ...info }
  })
}

export const updateJudgeScore = (info) => {
  return post({
    url: '/update_judge_score',
    data: { ...info }
  })
}

export const judgeDecision = (info) => {
  return post({
    url: '/post_judge_decision',
    data: { ...info }
  })
}

// —— Fase de grupos ——————————————————————————————————————————————————————

export const getGroupStage = (info) => {
  return post({ url: '/get_group_stage', data: { ...info } })
}

export const getGroupStandings = (info) => {
  return post({ url: '/get_group_standings', data: { ...info } })
}

export const setGroupStage = (info) => {
  return post({ url: '/set_group_stage', data: { ...info } })
}

export const generateGroups = (info) => {
  return post({ url: '/generate_groups', data: { ...info } })
}

// composição manual dos grupos (organizador escolhe quem vai em cada grupo)
export const setGroups = (info) => {
  return post({ url: '/set_groups', data: { ...info } })
}

// plano de grupos por categoria (quantos grupos, robôs aptos) — base da roleta
export const getGroupPlan = (info) => {
  return post({ url: '/get_group_plan', data: { ...info } })
}

// intervalo de almoço do evento (leitura pública; a agenda o exibe)
export const getEventLunch = (info) => {
  return post({ url: '/get_event_lunch', data: { ...info } })
}

export const generateBracketFromGroups = (info) => {
  return post({ url: '/generate_bracket_from_groups', data: { ...info } })
}
